export default __webpack_public_path__ + "static/media/logo_new.7c0940ba.svg";